import { DetailedTag } from 'src/services/tag/DetailedTag';
import { Tag } from 'src/services/tag/Tag';
import { hasChildren } from './hasChildren';
import { isParent } from './isParent';

export function archiveSelected(
  tag: Tag | DetailedTag,
  tags: DetailedTag[] | Tag[],
  isArchived = true
): DetailedTag[] | Tag[] | null {
  if (isArchived) {
    if (!hasChildren(tags, tag)) {
      tag.isArchived = isArchived;
      tags.find((t) => t.fullPath === tag.fullPath)!.isArchived = isArchived;
      return tags;
    } else {
      const confirmed = confirm(
        `${isArchived ? 'Archive' : 'Unarchive'} tag with all its children?`
      );

      if (confirmed) {
        // Archive or unarchive with all children
        tags.map((t) => {
          if (
            isParent(tag.fullPath, t.fullPath) ||
            t.fullPath === tag.fullPath
          ) {
            t.isArchived = isArchived;
          }
          return t;
        });
        return tags;
      } else {
        return null;
      }
    }
  } else {
    tags.find((t) => t.fullPath === tag.fullPath)!.isArchived = isArchived;
    // Unarchive all parents too
    tags.map((t) => {
      if (isParent(t.fullPath, tag.fullPath)) {
        t.isArchived = isArchived;
      }
      return t;
    });
    return tags;
  }
}
